// This is the root reducer of the feature. It is used for:
//   1. Load reducers from each action in the feature and process them one by one.
//      Note that this part of code is mainly maintained by Rekit, you usually don't need to edit them.
//   2. Write cross-topic reducers. If a reducer is not bound to some specific action.
//      Then it could be written here.
// Learn more from the introduction of this approach:
// https://medium.com/@nate_wang/a-new-approach-for-managing-redux-actions-91c26ce8b5da.

import initialState from './initialState';
import { reducer as loadSchemasFromCatalogoReducer } from './loadSchemasFromCatalogo';
import { reducer as createFileAssociationsReducer } from './createFileAssociations';
import { LOGOUT_USER } from '../../common/redux/constants'
import { reducer as getPublishAccountReducer } from './publishSideSheet/getPublishAccount'
import { reducer as createMeliPublicationReducer} from './publishSideSheet/createMeliPublication'
import { reducer as getExposureTypes } from './publishSideSheet/getExposureTypes'
import { reducer as getPublicationsReducer } from './publishSideSheet/getPublications'
import { reducer as updatePublicationReducer } from './publishSideSheet/updatePublication'
import { reducer as getSalesChannelReducer } from './publishSideSheet/getSalesChannel'
import { reducer as updateMeliPublicationReducer } from './publishSideSheet/updateMeliPublication'
import { reducer as openSideSheet } from './publishSideSheet/openSideSheet'
import { reducer as closeSideSheet } from './publishSideSheet/closeSideSheet'

const reducers = [
  loadSchemasFromCatalogoReducer,
  createFileAssociationsReducer,
  getPublishAccountReducer,
  updatePublicationReducer,
  getSalesChannelReducer,
  createMeliPublicationReducer,
  getExposureTypes,
  getPublicationsReducer,
  updateMeliPublicationReducer,
  openSideSheet,
  closeSideSheet,
];

export default function reducer(state = initialState, action) {
  let newState;
  switch (action.type) {
    // Handle cross-topic actions here
    case LOGOUT_USER:
      newState = initialState;
      break;
    default:
      newState = state;
      break;
  }
  return reducers.reduce((s, r) => r(s, action), newState);
}
